// i18n area 'vms' — locale uk-UA (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.uk-UA.meta.json.
import type { enUS } from './vms'

export const ukUA: typeof enUS = {
  vms: {
    spof: {
      title: 'Незалежність від вузла',
      single: 'Єдина точка відмови',
      alternativesNow: 'Альтернативи зараз',
      structural: 'За конструкцією',
      binding: 'Обмежувальна умова',
      movableNow: 'Міграція можлива зараз',
    },
    title: 'Віртуальні машини',
    migratingChip: 'Міграція триває',
    templateChip: 'Шаблон',
    expendableTooltip: 'У деградованому кластері вона серед перших, кого зупиняють, і може не перезапуститися після втрати вузла.',
    expendableHaTooltip: 'Завжди перезапускається, поки кластер здоровий; у деградованому кластері захищені ВМ ідуть першими — її можуть зупинити або вона залишиться вимкненою, доки кластер знову не стане цілим, потім повертається сама.',
    viewDetails: 'Переглянути деталі',
    profileLegacy: 'Інша ОС',
    hugePagesNone: 'Немає — звичайна пам’ять',
    hugePages2M: 'Сторінки по 2 MiB',
    hugePages1G: 'Сторінки по 1 GiB',
    searchPlaceholder: 'Пошук за назвою',
    name: 'Назва',

    // Термінологія UNA (#94a): фаза всюди зветься «Фаза» — старий ключ
    // 'state' помер разом із поліруванням списку.
    vcpus: 'vCPU',
    memory: 'Пам’ять',
    ipAddresses: 'IP-адреси',
    noIp: 'Немає IP',
    authorityNode: 'Авторитетний вузол',
    authorityNextStart: 'призначається при наступному запуску',
    scope: 'Скоуп',
    empty: 'Немає жодної віртуальної машини',
    loadError: 'Не вдалося завантажити віртуальні машини — чи доступний бекенд TVirt?',
    filterOverlay: 'оверлейна мережа',
    filterDisk: 'диск',
    filterImage: 'образ',
    filteredBy: 'Відфільтровано за: {kind}',
    filterPhase: 'Фаза',
    filterProtection: 'Захист',
    filterAll: 'Усі',
    filterScopePlaceholder: 'Фільтр за скоупом',
    filtersToggle: 'Фільтри',
    scopeTree: {
      title: 'Скоупи',
      all: 'Увесь кластер',
      noChildren: 'Тут немає вкладених скоупів',
      recursive: 'Включати нащадків',
      collapse: 'Згорнути панель скоупів',
      up: 'На рівень вище',
      countTooltip: '{direct} ВМ у цьому скоупі · {total} разом із нащадками'
    },

    // Двокроковий вибір ISO (#85): спершу каталог, потім його образи ISO.
    isoPicker: {
      catalog: 'Каталог',
      unknownCatalog: 'Поза видимими каталогами',
      noIsos: 'У цьому каталозі немає готового образу ISO'
    },
    actionsHeader: 'Дії',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Обладнання',
      tags: 'Теги',
      age: 'Вік',
      disk: 'диск',
      disks: 'дисків',
      empty: 'Немає жодного шаблона — позначте вимкнену ВМ як шаблон або клонуйте ВМ як шаблон.',
      clone: 'Клонувати / розгорнути',
      editTags: 'Змінити теги',

      // Раунд K3 (#64): експортує шаблон як файл .tvtpl у каталог.
      exportAction: 'Експортувати в каталог (.tvtpl)',
      exportTitle: 'Експортувати в каталог',
      exportSubmit: 'Експортувати',
      exportError: 'Експорт не вдався',
      exportHint: 'Шаблон пакується в архів .tvtpl (маніфест обладнання + кожен диск, сплощений у qcow2) як новий файл «Шаблон ВМ» у вибраному каталозі. NIC, носії CD/DVD і cloud-init не мандрують — специфікація формату перелічує кожен свідомий пропуск.',
      exportName: 'Назва файлу',
      exportNameHint: 'Порожньо = <шаблон>-export-<n>',
      exportStorageDefault: 'Сховище метаданих шаблона',

      // Імпорт із каталогу (Luca 2026-08-03): вхід на панелі інструментів
      // вкладки «Шаблони» — бекенд K3/K4 покриває всі формати vm-template,
      // вибирають саме ФАЙЛ (формат мандрує лише для читання).
      importAction: 'Імпортувати з каталогу',
      importTitle: 'Імпортувати з каталогу',
      importHint: 'Готовий файл «Шаблон ВМ» із вибраного каталогу стає шаблоном в інвентарі: формат файлу (tvtpl, ova, ovf чи голий qcow2) сам вирішує, як його імпортувати, — ви обираєте лише файл.',
      importFile: 'Файл каталогу',
      importFileHint: 'Імпортуються лише готові файли — той, що на півдорозі вивантаження, не імпортується',
      importNoFiles: 'У цьому каталозі немає готового файлу «Шаблон ВМ» — спершу вивантажте або експортуйте один'
    },
    templateDetail: {
      quickDeploy: 'Сумісність із QuickDeploy',
      quickDeployNone: 'Не задекларована',
      quickDeployHint: 'Декларуйте її лише якщо golden-образ містить cloud-init (Linux) або cloudbase-init після sysprep /generalize (Windows): платформа довіряє декларації та ніколи не зазирає всередину гостя.',
      notFound: 'Шаблон не знайдено',
      frozen: 'Конфігурацію обладнання заморожено: щоб змінити її, перетворіть шаблон назад на ВМ. Назва, нотатки й теги лишаються редагованими.',
      storage: 'Сховище',
      size: 'Розмір',
      configTitle: 'Конфігурація (заморожена)',
      usbClasses: 'Потрібні класи USB',
      gpuClasses: 'Потрібні класи GPU'
    },
    sharedDisksTab: {
      title: 'Спільні диски',
      sharing: 'Спільне використання',
      sharingNone: 'Одне під\'єднання',
      sharingMultiwriter: 'Спільний запис (multiwriter)',
      sharingReadonly: 'Спільне лише читання',
      usedBy: 'Використовується',
      attachedTo: 'Під\'єднано до',
      notAttached: 'Не під\'єднано до жодної VM',
      changeSharing: 'Змінити режим спільного використання',
      changeSharingTitle: 'Режим спільного використання',
      changeSharingLocked: 'Режим змінюється, лише поки диск не використовує жодна VM',
      sharingChanged: 'Режим спільного використання оновлено.',
      lun: 'Цілий LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Серійний номер',
      antiAffinityWarning: 'Два або більше учасників працюють на одному вузлі без правила анти-афінності: відмова одного вузла покладе всіх',
      antiAffinityCreate: 'Створити правило',
      createSourceLun: 'Прийняти цілий LUN таргета',
      createLunNumber: 'Номер LUN (id namespace на NVMe)',
      createLunHint: 'Нічого не виділяється: розмір зчитується з пристрою під час прийняття',
      noPr: 'У цьому випуску немає SCSI-3 persistent reservations: Windows Failover Cluster із класичним спільним диском не валідовано; кластери, що координуються мережею (GFS2/OCFS2, RHEL HA, бази shared-disk), — так'
    },
    unusedDisksTab: {
      title: 'Невикористані диски',
      attach: 'Під’єднати до ВМ',
      attachTitle: 'Під’єднати до ВМ',
      vm: 'Віртуальна машина',
      noVms: 'Немає доступної ВМ',
      noSlots: 'На цій ВМ немає вільного слота',

      // Створення окремого диска (#87): повернулося з пенсіонованого
      // «Інвентаря», тепер із ЯВНИМ полем скоупа (немає ВМ, від якої успадкувати).
      create: 'Створити диск',
      createTitle: 'Створити диск',
      createSourceBlank: 'Порожній диск',
      createSourceImage: 'З образу в каталозі',
      createImage: 'Образ',
      createImageEmpty: 'У видимих каталогах немає готового образу шаблону ВМ',
      createSizeFromImageHint: 'Попередньо заповнено віртуальним розміром образу — може лише зростати',

      // #107 (РУЙНІВНО, ратифіковано): qcow2 → файл каталогу vm-template
      // на тому самому сховищі, нуль скопійованих байтів — диск перестає існувати.
      convert: 'Перетворити на шаблон ВМ…',
      convertOnlyQcow2: 'Перетворюються лише диски qcow2 — raw не є форматом шаблона, який можна зареєструвати',
      convertTitle: 'Перетворити на шаблон ВМ',
      convertSubmit: 'Перетворити (знищує диск)',
      convertError: 'Не вдалося запустити перетворення',
      convertWarning: 'РУЙНІВНО: диск стає файлом шаблона ВМ у вибраному каталозі — те саме сховище, нуль скопійованих байтів — і ПЕРЕСТАЄ ІСНУВАТИ як диск. Назад дороги немає, хіба що створити з шаблона новий диск.',
      convertNameHint: 'Назва файлу каталогу — типово така сама, як у диска',
      convertConfirm: 'Я розумію: диск буде знищено',
      convertStarted: 'Перетворення розпочато — шаблон з’явиться в каталозі, коли завдання завершиться.',
      storageLockHint: 'Сховище змінюється лише дією «Перемістити»',
      source: 'Походження',
      sourceClone: 'Клон іншого диска',
      sourceCloneLinked: 'Пов’язаний клон іншого диска',
      sourceImage: 'Створений з образу',
      sourceBlank: 'Створений порожнім',
      allocated: 'Виділено / віртуальний розмір',
      observedAt: 'Спостережено',
      snapshots: 'Знімки',
      snapshotsEmpty: 'Знімків немає'
    },
    phase: {
      defined: 'Ніколи не вмикалася',
      starting: 'Запускається',
      running: 'Виконується',
      stopping: 'Зупиняється',
      stopped: 'Вимкнена',
      paused: 'На паузі',
      failed: 'Помилка',
      deleting: 'Видаляється'
    },
    stopCause: {
      'api': 'Зупинено з TVirt (дією або через API)',
      'guest-shutdown': 'Вимкнення, ініційоване гостьовою операційною системою',
      'crash': 'Аварія гостьової системи',
      'qemu-exit': 'Процес QEMU завершився несподівано',
      'host-reboot': 'Вузол було перезавантажено',
      'migrated': 'Мігрувала на інший вузол',
      'fenced': 'Завершено фенсингом HA (вузол повернувся)'
    },
    detail: {
      notFound: 'Віртуальну машину не знайдено',
      details: 'Деталі',
      id: 'ID',
      scope: 'Скоуп',
      profile: 'Профіль обладнання',
      firmware: 'Прошивка',
      firmwareFile: 'Версія прошивки UEFI',
      firmwareUpdate: 'Доступне оновлення',
      firmwareUpdateHint: 'Платформа постачає новішу прошивку UEFI. Оновлення ніколи не автоматичне: воно застосовується на вимкненій ВМ, коли ти так вирішиш.',
      arch: 'Архітектура',
      node: 'Вузол',
      bootOrder: 'Порядок завантаження',
      agent: 'Стан агента',
      agentConnected: 'Під’єднано',
      agentNotConnected: 'Не під’єднано',
      protected: 'Захищена',
      linkedClones: 'Пов’язані клони',
      restartPolicy: 'Політика перезапуску',
      preferredNode: 'Бажаний вузол',
      noPreference: 'Без переваги (автоматичне розміщення)',
      preferNodes: 'Бажані теги вузла',
      requireNodes: 'Обов’язкові теги вузла',
      noPlacementTags: 'Немає',
      placementTag: 'Тег',
      placementValue: 'Значення',
      placementAddTag: 'Додати тег',
      proximityHa: 'HA від TVirt Proximity',
      proximityHaRestarts: 'перезапусків HA',
      proximityHaGaveUp: 'цикл аварій — HA здалася',
      failoverProtection: 'Захист у деградованому кластері',
      protectionProtected: 'Захищена',
      protectionExpendable: 'Жертовна при деградації',
      protectionInherit: 'Успадкувати',
      lastStop: 'Останнє зупинення',
      yes: 'Так',
      no: 'Ні',
      tabOverview: 'Огляд',
      tabSnapshots: 'Знімки',
      tabBackups: 'Копії',
      hardware: 'Обладнання',
      name: 'Назва',
      hwSystem: 'Система',
      hwCpu: 'CPU',
      hwMemory: 'Пам’ять',
      hwBoot: 'Завантаження',
      hwIdentity: 'Ідентичність',
      hwCluster: 'Кластер і агент',
      cpuTopology: 'Топологія CPU',
      cpuModel: 'Модель CPU',
      cpuLimit: 'Ліміт CPU',
      cpuWeight: 'Вага CPU',
      cpuNested: "Вкладена віртуалізація",
      cpuNestedHint: "Відкриває гостю vmx/svm (лише з моделлю CPU host). На запущеній ВМ зміна набуде чинності після наступного power cycle (PendingRestart); розміщення допускає лише вузли з увімкненим nested.",
      unlimited: 'Без обмежень',
      memory: 'Пам’ять',
      balloon: 'Балун',
      hugePages: 'Величезні сторінки',
      hugePagesTradeoff: 'Менше роботи з трансляції адрес і пам’ять, яка ніколи не потрапляє на диск; натомість резервування лишається прив’язаним до вузла, доки ВМ працює, пам’ять більше не дедуплікується, а старт зривається, якщо на вузлі замало вільних сторінок.',
      disks: 'Диски',
      cdroms: 'Приводи CD/DVD',
      nics: 'Мережеві інтерфейси',
      slot: 'Слот',
      disk: 'Диск',
      encrypted: 'Зашифрований',
      image: 'Образ',
      emptyDrive: 'Порожній привід',
      emptyOption: '(порожньо)',
      network: 'Мережа',
      mac: 'MAC',
      connected: 'Під’єднана',
      unplugged: 'Від’єднана',
      noDevices: 'Немає',
      screenshot: 'Знімок екрана',
      capturedAt: 'Знято о',
      noCapture: 'Знімка немає',
      snapshotName: 'Назва',
      snapshotCreated: 'Створено',
      snapshotMemory: 'Пам’ять включено',
      noSnapshots: 'Знімків немає',
      pendingRestart: 'Зміни очікують: їх буде застосовано при наступному циклі живлення.',
      applied: 'застосовано',
      appliedHint: 'ВМ працює саме з цим значенням — налаштоване застосується при наступному циклі живлення.',
      actionError: 'Дію не виконано',
      actionStillRunning: 'Дія ще виконується — результат поки невідомий',
      tabConsole: 'Консоль',
      consoleConnect: 'Під’єднатися',
      consoleDisconnect: 'Від’єднатися',
      consoleConnecting: 'З’єднання…',
      consoleReconnecting: 'З’єднання…',
      consoleUnavailable: 'Консоль доступна, коли ВМ виконується або стоїть на паузі.',
      consoleError: 'Не вдалося з’єднатися з консоллю',
      consoleTaken: 'Сеанс консолі перехопив користувач {user}',
      consoleReconnect: 'Перез’єднатися',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Утримувати {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Відкрити на весь екран у новій вкладці',
      consoleLoadFailed: 'ВМ не знайдено або бракує дозволів',
      consoleClose: 'Закрити',
      tabStats: 'Статистика',
      tabTasks: 'Завдання',
      tabLogs: 'Журнал',
      statsCpu: 'CPU',
      statsMemory: 'Пам’ять',
      statsDisk: 'I/O диска',
      statsRange: 'Інтервал',
      statsNoData: 'В інтервалі немає даних — статистика збирається, коли ВМ виконується.',
      statsError: 'Не вдалося завантажити статистику',
      cpuUsage: 'Використання',
      cpuReady: 'Готовність (%RDY)',
      memUsed: 'Використано',
      memGuestAvailable: 'Доступно (гостьова система)',
      schema: 'Схема',
      consoleProtocol: 'Консоль',
      agentEnabled: 'Гостьовий агент',
      metadataStorage: 'Сховище метаданих',
      startupOnBoot: 'Запуск під час завантаження',
      startupOrder: 'Порядок запуску',
      startupDelay: 'Затримка запуску',
      seconds: 'с',
      enabled: 'Увімкнено',
      disabled: 'Вимкнено'
    },
    actionsAvailable: 'Доступні дії',
    actions: {
      start: 'Запустити',
      stop: 'Зупинити',
      pause: 'Пауза',
      resume: 'Продовжити',
      reset: 'Скинути',
      migrate: 'Мігрувати',
      clone: 'Клонувати',
      moveStorage: 'Перемістити на сховище…',
      moveScope: 'Перемістити у скоуп…',
      openConsole: 'Відкрити консоль',
      forceStop: 'Примусово вимкнути',
      markTemplate: 'Позначити як шаблон',
      unmarkTemplate: 'Перетворити назад на ВМ',
      error: 'Не вдалося виконати дію'
    },
    cordon: {
      confirmTitle: 'Вузол на обслуговуванні',
      confirmHint:
        'Кордон не можна опустити, доки сховище кластера недоступне. Підтверджуючи, ви заявляєте, що знаєте про це: ВМ усе одно запуститься там, а згода залишиться записаною в задачі.',
      confirm: 'Усе одно запустити'
    },
    markTemplate: {
      confirmTitle: 'Позначити {name} як шаблон?',
      confirmBody: 'Конфігурація заморожується, і ВМ більше не зможе вмикатися — лише клонуватися або знову стати ВМ. Назва, нотатки й теги лишаються редагованими.',
      confirm: 'Позначити як шаблон',
      moved: '{name} тепер шаблон — переїхала у вкладку «Шаблони».'
    },
    unmarkTemplate: {
      confirmTitle: 'Перетворити {name} назад на ВМ?',
      confirmBody: 'Шаблон знову стає звичайною ВМ: її можна змінювати й запускати (наступний запуск розмістить її на вузлі).',
      confirm: 'Перетворити назад на ВМ',
      moved: '{name} знову віртуальна машина — переїхала у вкладку «Віртуальні машини».'
    },

    // Раунд #123: посилання на вузол за ТЕГОМ (селектор #106) у діалогах
    // запуску та міграції — разом із попереднім переглядом розв’язаного набору.
    nodeByTag: {
      label: 'За тегом вузла',
      hint: 'тег=значення, через кому (за І): вирішувач обирає серед відповідних вузлів',
      invalid: 'Неприпустимий формат — використовуйте тег=значення, через кому',
      resolved: 'Відповідні учасники: {nodes}'
    },
    migrate: {
      title: 'Жива міграція',
      submit: 'Мігрувати',
      target: 'Вузол призначення',
      auto: 'Автоматично (Proximity)',
      hint: 'ВМ переїжджає без циклу живлення. Кожне сховище, якого вона торкається, має бути спільним; ВМ на паузі мігрує на паузі.',
      error: 'Міграцію відхилено'
    },
    moveStorage: {
      title: 'Перемістити на сховище',
      submit: 'Перемістити',
      target: 'Сховище призначення',
      noTargets: 'Жодне сховище не приймає дисків',
      hint: 'Усі диски вимкненої ВМ мандрують на вибране сховище, по одному, зберігаючи свій id — ті, що вже на місці, пропускаються. Прогрес живе на сторінці завдань.',
      error: 'Переміщення відхилено'
    },
    moveScope: {
      title: 'Перемістити у скоуп',
      submit: 'Перемістити',
      target: 'Скоуп призначення',
      hint: 'ВМ негайно змінює скоуп — id і диски лишаються, власні диски прямують за нею, і вона може лишатися ввімкненою. Сьогодні вона живе у {scope}. Разом зі скоупом змінюється й те, хто її бачить.',
      error: 'Переміщення у скоуп відхилено'
    },
    start: {
      title: 'Запустити ВМ',
      submit: 'Запустити',
      target: 'Вузол призначення',
      auto: 'Автоматично (рекомендовано)',
      recommended: 'рекомендовано',
      hint: 'Виберіть вузол призначення або дайте Proximity вирішити серед придатних кандидатів. Вузли, які не можуть її прийняти, вимкнені із зазначенням причини.',
      error: 'Не вдалося запустити ВМ'
    },
    console: {
      media: 'Приводи CD/DVD',
      mediaGuestToolsHint: 'Містить TVirt Guest Tools — звідси ви можете витягти їх або вилучити привід',
      slotOpsDeferred: 'На цьому профілі додавання й вилучення приводів застосовуються при наступному циклі живлення (зміна носія — миттєва).',
      mountGuestTools: 'Змонтувати TVirt Guest Tools',
      ejectGuestTools: 'Витягти TVirt Guest Tools',
      bootOrder: 'Порядок завантаження',
      bootOrderHint: 'Новий порядок зберігається одразу й застосовується при наступному циклі живлення — сеанс консолі лишається під’єднаним.'
    },
    snapshots: {
      create: 'Створити знімок',
      createTitle: 'Створити знімок',
      createSubmit: 'Створити',
      name: 'Назва',
      nameHint: 'Літери, цифри, крапка, дефіс, підкреслення.',
      consistencyHint: 'Узгодженість автоматична: гостьовий агент заморожує файлові системи, коли відповідає; інакше ВМ на мить стає на паузу навколо знімка.',
      memory: 'Включити пам’ять',
      memoryHint: 'Захоплює живу RAM: відновлення повертає ВМ у виконання. Потребує, щоб усі диски були qcow2.',
      currentChip: 'Ви тут',
      revert: 'Відновити',
      revertTitle: 'Відновити {name}?',
      revertBody: 'Диски повертаються до стану знімка; усе, що сталося після, буде втрачено. Знімок лише дисків потребує зупиненої ВМ.',
      delete: 'Видалити',
      deleteTitle: 'Видалити знімок {name}?',
      deleteBody: 'Точка відновлення зникає; вміст дисків лишається недоторканим.',
      deleteMergeHint: 'Її дельта зливається у {children}: кожна пізніша точка відновлення лишається чинною.',
      deleteDuplication: 'Приймаю дублювання',
      deleteDuplicationHint: 'Дельта копіюється в кожен із {count} читачів (дочірні snapshot і, якщо цей є поточним, активну голову): зайняте місце може зрости замість зменшитися.',
      error: 'Операцію над знімком відхилено'
    },
    clone: {
      title: 'Клонувати ВМ',
      submit: 'Клонувати',
      name: 'Назва копії',
      storage: 'Сховище призначення для дисків',
      sameStorage: 'Те саме, що й у джерела',
      full: 'Повна копія',
      fullHint: 'Копіює кожен байт і розриває зв’язок із дисками джерела. Типово робиться пов’язаний клон: миттєвий, але прикутий до джерела (лише qcow2).',
      hint: 'Клон зберігає конфігурацію та прошивку джерела; MAC-адреси й ідентичність TPM — нові.',
      markAs: 'Тип клона',
      markAsInheritVm: 'Як у джерела (ВМ)',
      markAsInheritTemplate: 'Як у джерела (шаблон)',
      markAsVm: 'Віртуальна машина',
      markAsTemplate: 'Шаблон',
      markAsHintVm: 'Виберіть «Шаблон», щоб підвищити копію одним кроком.',
      markAsHintTemplate: 'Виберіть «Віртуальна машина», щоб розгорнути з цього шаблона одним кроком.',
      error: 'Клонування відхилено'
    },
    bulk: {
      selected: 'вибрано',
      deleteTitle: {
        one: 'Видалити {count} вибрану ВМ?',
        few: 'Видалити {count} вибрані ВМ?',
        many: 'Видалити {count} вибраних ВМ?',
        other: 'Видалити {count} вибраної ВМ?'
      },
      deleteBody: 'Кожна ВМ проходить ті самі перевірки, що й при одиночному видаленні; відмови повідомляються поелементно.',
      done: 'прийнято',
      refused: 'відхилено'
    },
    delete: {
      button: 'Видалити',
      confirmTitle: 'Видалити {name}?',
      confirmBody: 'Віртуальну машину та її власні диски буде видалено. Операція незворотна.',
      keepDisks: 'Зберегти диски',
      keepDisksHint: 'Диски, створені разом із ВМ, лишаються у своїх сховищах як самостійні диски.',
      confirm: 'Видалити',
      cancel: 'Скасувати',
      error: 'Видалення не вдалося',
      blockedPhase: 'Спершу зупиніть ВМ',
      blockedProtected: 'ВМ захищена — спершу зніміть захист',
      blockedDeleting: 'Видалення вже триває'
    },
    logs: {
      title: 'Журнал',
      subtitle: 'Структуровані кадри журналу завдань, які торкаються цієї ВМ',
      when: 'Коли',
      task: 'Завдання',
      level: 'Рівень',
      message: 'Повідомлення',
      empty: 'Записів журналу ще немає',
      loadError: 'Не вдалося завантажити журнал — чи доступний бекенд TVirt?'
    },
    stop: {
      title: 'Зупинити віртуальну машину',
      modeGraceful: 'Штатне вимкнення',
      modeGracefulHint: 'Гостьову операційну систему просять вимкнутися природним чином (ACPI); якщо вона ігнорує запит, після тайм-ауту спрацьовує примусове вимкнення.',
      modeForced: 'Примусове вимкнення',
      modeForcedHint: 'Негайно знімає живлення — наче висмикнути шнур із розетки.',
      timeout: 'Тайм-аут запасного шляху (секунди)',
      timeoutHint: 'Час, наданий гостьовій системі, перш ніж вимкнути примусово'
    },

    // Меню кнопки створення з розділенням (Luca 2026-07-23): «З нуля» відкриває
    // майстер, інші два пункти — заглушки з дорожньої карти.
    createFromScratch: 'З нуля',
    createFromTemplate: 'З шаблона',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Виконати deploy',
      error: 'Deploy не вдався',
      compatNote: 'QuickDeploy вимагає шаблон, сумісний із QuickDeploy: платформа налаштовує гостя (мережа, домен, активація) під час першого запуску.',
      template: 'Шаблон',
      noTemplates: 'Жоден шаблон ще не декларує сумісність із QuickDeploy — задекларуйте її на вкладці Шаблони (Linux із cloud-init, Windows із cloudbase-init після sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Ім\'я хоста',
      hostnameHint: 'Ім\'я хоста або FQDN; порожньо = ім\'я VM (Windows: не більше 15 символів)',
      ip: 'IP-адреса',
      ipHint: 'Хост і префікс, напр. 192.168.122.101/24; порожньо = DHCP',
      gateway: 'Шлюз',
      dns: 'DNS-сервери',
      dnsHint: 'До трьох, через кому',
      count: 'Екземпляри',
      countHint: 'Більше одного: імена <ім\'я>-1…-N, лише DHCP',
      user: 'Користувач',
      userHint: 'Порожньо = типовий користувач образу (Linux) або Administrator (Windows)',
      password: 'Пароль',
      passwordHint: 'Записується у згенерований user-data, який платформа потім оголошує секретним: ніхто його більше не прочитає',
      sshKeys: 'Публічні ключі SSH',
      sshKeysHint: 'По одному на рядок (ssh-ed25519 AAAA… коментар)',
      productKey: 'Ключ продукту Windows',
      kmsServer: 'Сервер KMS',
      kmsHint: 'Хост або хост:порт — потребує ключа продукту (клієнтського ключа KMS)',
      adDomain: 'Приєднати до домену Active Directory',
      adDomainHint: 'Порожньо = без приєднання до домену',
      adUser: 'Обліковий запис для приєднання',
      adPassword: 'Пароль облікового запису для приєднання',
      adOu: 'Цільова OU (необов\'язково)',
      advanced: 'Додатково: сирі документи',
      userData: 'user-data (сирий)',
      userDataHint: 'Замінює згенерований user-data: користувач, пароль, ключі та поля Windows вище мають залишитися порожніми',
      networkConfig: 'network-config (сирий)',
      networkConfigHint: 'Замінює згенеровану мережу: IP, шлюз і DNS вище мають залишитися порожніми',
      secret: 'Вважати сирий user-data секретним',
      secretHint: 'Позначений секретним, він більше не повертається API нікому і подорожує в Checkpoint запечатаним masterpass',
      startNow: 'Запустити одразу',
      startNowHint: 'Кожен екземпляр запускається, щойно визначений; seed створюється під час цього запуску'
    },

    create: {
      nicAttachmentNetwork: 'Логічна мережа (fabric)',
      nicNetwork: 'Логічна мережа',
      nicNetworkHint: 'РЕКОМЕНДОВАНИЙ шлях (F3): vNIC реалізується на ПОХІДНОМУ мості обслуговуючого вузла — міст народжується при явному apply fabric, а запуск на вузлі, що його ще не несе, відмовляє говорячи. Коли йде останнє посилання флоту, міст випадає при наступному apply.',
      button: 'Створити ВМ',
      title: 'Створити віртуальну машину',
      dialogTitle: 'Створити віртуальну машину',
      stepGeneral: 'Загальне',
      stepGeneralHint: 'Назва та профіль',
      stepCompute: 'CPU і RAM',
      stepComputeHint: 'Топологія та розміри',
      stepDisks: 'Диски',
      stepDisksHint: 'Створити або під’єднати',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Приводи та носії',
      stepNetwork: 'Мережа',
      stepNetworkHint: 'NIC: транк або бридж',
      stepSummary: 'Підсумок',
      stepSummaryHint: 'Перевірити та створити',
      name: 'Назва',
      nameHint: 'Малі літери, цифри й дефіси (DNS-1123)',
      nextButton: 'Далі',
      prevButton: 'Назад',
      submitButton: 'Створити',
      creating: 'Створення…',
      sockets: 'Сокети',
      cores: 'Ядер на сокет',
      threads: 'Потоків на ядро',
      totalVcpus: 'Усього vCPU',
      memoryGib: 'Пам’ять (GiB)',
      cpuModelHint: "'host' відкриває CPU хоста",
      cpuLimitHint: 'Стеля в ядрах хоста — порожньо = без обмежень',
      cpuNestedHint: "Відкриває гостю vmx/svm, щоб він міг запускати власний гіпервізор — потрібна модель CPU host і вузол з увімкненим nested",
      newDisk: 'Новий диск',
      attachDisk: 'Під’єднати наявний диск',
      diskStorage: 'Сховище',
      diskSize: 'Розмір (GiB)',
      diskSelect: 'Диск',
      addDisk: 'Додати диск',
      addCdrom: 'Додати привід CD/DVD',
      addNic: 'Додати мережевий інтерфейс',
      remove: 'Вилучити',
      slotLimit: 'Досягнуто ліміту слотів',
      cdromImage: 'Образ (порожній привід, якщо не вказано)',
      nicAttachment: 'Підключення',
      nicAttachmentTrunk: 'Транк оверлею',
      nicAttachmentBridge: 'Бридж хоста',
      nicUntagged: 'Оверлей без тегу',
      nicUntaggedNone: 'Немає (лише з тегами)',
      nicTrunkHint: 'Щонайменше одна сторона: оверлей без тегу та/або зіставлення VLAN з тегами — ВМ може працювати лише на хостах, оголошених кожним згаданим оверлеєм',
      nicTaggedVlan: 'ID VLAN',
      nicTaggedOverlay: 'Оверлейна мережа',
      addTagged: 'Додати VLAN з тегом',
      nicBridge: 'Назва бриджа хоста',
      nicBridgeHint: 'Бридж NM за назвою — ВМ може працювати лише на серверах, чия мережа хоста оголошує цей бридж',
      nicMac: 'MAC (автоматично, якщо порожньо)',
      noDisksHint: 'Жодного диска: ВМ матиме лише приводи CD/DVD, які ви додасте.',
      noCdromsHint: 'Жодного привода CD/DVD: додайте один, щоб завантажитися з образу ISO.',
      mountGuestTools: 'Змонтувати TVirt Guest Tools при першому запуску',
      mountGuestToolsHint: 'Кладе ISO з драйверами virtio та гостьовим агентом у порожній привід CD (додається за потреби) — інсталятору Windows він потрібен, щоб побачити диски.',
      noNicsHint: 'Жодного мережевого інтерфейсу: ВМ запуститься без зв’язку.',
      taggedMappings: 'Зіставлення VLAN з тегами',
      summaryDevices: 'Пристрої',
      bootOrderTitle: 'Порядок завантаження',
      bootOrderHint: 'Перетягуйте, щоб змінити порядок, — перемагає перший придатний до завантаження пристрій; NIC завантажуються через PXE',
      bootOrderUp: 'Перемістити вгору',
      bootOrderDown: 'Перемістити вниз',
      createError: 'Створення не вдалося'
    },
    edit: {
      button: 'Змінити',
      title: 'Змінити віртуальну машину',
      cancel: 'Скасувати',
      save: 'Зберегти',
      error: 'Зміна не вдалася',
      modelStoppedOnly: 'Змінюється лише на вимкненій ВМ',
      firmwareStoppedOnly: 'Прошивка змінюється лише на вимкненій ВМ — при наступному запуску машина стартує з новою прошивкою, а змінні UEFI лишаються',
      hugePagesStoppedOnly: 'Змінюється лише на вимкненій ВМ — при наступному запуску пам’ять народжується на новій основі',
      runningHint: 'Зміни застосовуються при наступному циклі живлення',
      sectionCpu: 'CPU',
      sectionMemory: 'Пам’ять',
      sectionPolicy: 'Політики'
    },
    devices: {
      networkChip: 'мережа fabric',
      title: 'Пристрої',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Додати пристрій USB',
      addUsbTitle: 'Запросити клас пристроїв USB',
      usbClassHint:
        'ВМ просить КЛАС пристроїв USB (значення тегу usb-device), ніколи не конкретний пристрій: під час запуску вільний конкретний пристрій на вузлі обирається й резервується. Позначайте теги зареєстрованих пристроїв у розділі «Кластер › Ресурси USB та PCIe».',
      usbTag: 'Тег (usb-device)',
      usbValue: 'Значення класу',
      noUsbTags: 'Немає тегу usb-device — створіть його й позначте зареєстровані пристрої в розділі «Кластер › Ресурси USB та PCIe».',
      noUsbValues: 'Цей тег ще не має оголошених значень.',
      usbEmpty: 'Немає вимог до USB — додайте клас, щоб передати пристрій під час запуску.',
      usbClassChip: 'клас',
      usbPortChip: 'порт',
      usbUnclaimed: 'Жодного зарезервованого пристрою — розв’язується під час запуску ВМ.',
      addGpu: 'Додати GPU',
      addGpuTitle: 'Запросити клас GPU',
      gpuClassHint:
        'ВМ просить КЛАС GPU (значення тегу gpu-device), ніколи не конкретну плату: під час запуску вільна конкретна плата обирається й резервується на вузлі та передається РАЗОМ з усією своєю групою IOMMU. Позначайте теги зареєстрованих GPU у розділі «Кластер › Ресурси USB та PCIe».',
      gpuTag: 'Тег (gpu-device)',
      gpuValue: 'Значення класу',
      noGpuTags: 'Немає тегу gpu-device — створіть його й позначте зареєстровані GPU в розділі «Кластер › Ресурси USB та PCIe».',
      noGpuValues: 'Цей тег ще не має оголошених значень.',
      gpuEmpty: 'Немає вимог до GPU — додайте клас, щоб передати плату під час запуску.',
      gpuClassChip: 'клас',
      gpuGroupChip: 'група IOMMU ×',
      gpuUnclaimed: 'Жодної зарезервованої плати — розв’язується під час запуску ВМ.',
      gpuPowerCycle: 'Жодного гарячого підключення GPU — зміни діють від наступного циклу живлення (PendingRestart)',
      actions: 'Дії',
      attachDisk: 'Додати диск',
      attachDiskTitle: 'Додати диск',
      attach: 'Під’єднати',
      noFreeDisks: 'Немає невикористаних дисків — створіть один у розділі «Віртуальні машини › Невикористані диски».',
      addCdrom: 'Додати привід',
      addCdromTitle: 'Додати привід CD/DVD',
      editCdromTitle: 'Змінити образ CD/DVD',
      changeMedia: 'Змінити образ CD/DVD',
      ejectMedium: 'Витягти',
      mountGuestTools: 'Змонтувати TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools змонтовано',
      guestToolsClickMount: 'Кладе ISO з TVirt Guest Tools у перший порожній привід CD/DVD',
      guestToolsClickUnmount: 'Натисніть, щоб витягти — привід лишається порожнім',
      guestToolsNoSlot: 'Немає порожнього привода CD/DVD — додайте привід (або витягніть носій), щоб змонтувати TVirt Guest Tools',
      guestToolsSkew: 'Змонтовано v{pinned}; вузол {node} тепер надає v{current}: витягніть і змонтуйте знову, щоб оновити',
      ejectGuestTools: 'Витягти TVirt Guest Tools (привід лишається порожнім)',
      guestToolsEjectConfirmTitle: 'Витягти TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Носій витягується з увімкненої ВМ — привід CD/DVD лишається порожнім.',
      applyLive: 'Застосувати одразу (ВМ увімкнена)',
      addNic: 'Додати інтерфейс',
      addNicTitle: 'Додати мережевий інтерфейс',
      editNicTitle: 'Змінити мережевий інтерфейс',
      bridgeChip: 'бридж',
      cable: 'Віртуальний кабель',
      plug: 'Під’єднати віртуальний кабель',
      unplug: 'Від’єднати віртуальний кабель',
      remove: 'Вилучити',
      removeTitle: 'Вилучити {device}?',
      removeBody: 'На ввімкненій ВМ зміна застосується при наступному циклі живлення. Диски та образи від’єднуються, ніколи не видаляються.'
    }
  }
}
